var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-progress-circular',{staticClass:"blue--text",attrs:{"indeterminate":"","width":7,"size":70}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }